import { render, staticRenderFns } from "./NeTitle.vue?vue&type=template&id=4b71d1ce&scoped=true&"
import script from "./NeTitle.vue?vue&type=script&lang=js&"
export * from "./NeTitle.vue?vue&type=script&lang=js&"
import style0 from "./NeTitle.vue?vue&type=style&index=0&id=4b71d1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71d1ce",
  null
  
)

export default component.exports